module.exports = __webpack_public_path__ + "img/978788679.4903e81b.jpg";